// extracted by mini-css-extract-plugin
export default {"input":"soYXU","button":"DzeRy","inline-button":"f7jKS"};